// Form validation for Technician Group form
import { plaintextValidator, urlValidator } from '../fields';

export default {
  entityId: plaintextValidator({ mandatory: true }),
  certificate: plaintextValidator({ mandatory: true }),
  idpLoginUrl: urlValidator({ mandatory: true }),
  name: plaintextValidator({ mandatory: true }),
  clients: {
    presence: true,
    length: {
      minimum: 1
    },
    array: {
      accountId: {
        presence: true
      }
    }
  }
};
